import React from 'react'

export default function Support() {
  return (
    <section>
      <a className="anchor" id="support"></a>
      <h2>Support</h2>
      <br/>
      <h3>Need help?</h3>
      <p>Join the <a className="btn" href="https://hipchat.chicago.cme.com/chat/room/414" target="_blank">Hipchat</a> room.</p>
      <h4>Issue / Feature request</h4>
      <p>Raise a <button className="btn jira-button">Jira</button> ticket. These will be reviewed and prioritised</p>

	  <br/><br/>
	  <hr/>
    </section>
  )
}



// WEBPACK FOOTER //
// ./styleguide/components/sections/Support.js